import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import NavBar from "../../components/Nav";
import Backdrop from "../../components/SlideDrawer";
import SideNav from "../../components/SideNav";
import BottomNav from "../../components/BottomNav";
import Sidebar from "react-sidebar";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import LoadValidations from "../../components/LoadValidations/LoadValidations";
import { useServiceWorker } from "../../components/CustomHooks/useServiceWorker";
import { Main } from "../../components/Main";
import { UpdatePwa } from "../../components/UpdatePWA";
import ErrorPage from "../ErrorPage/ErrorPage";
import ErrorBoundary from "../../components/ErrorBoundary";
import Spinner from "../../components/common/Spinner";
import { NotificationSnackbar } from "../../components/NotificationSnackbar/NotificationSnackbar";

export default function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {
    isUpdateAvailable,
    updateAssets,
    checkForUpdate,
    noUpdateAvailable,
    updateError,
    isCheckingForUpdate,
  } = useServiceWorker();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    updateAssets();
  };

  const drawerToggleClickHandler = () => {
    setDrawerOpen(true);
  };

  const backdropClickHandler = () => {
    setDrawerOpen(false);
  };

  let backdrop;
  if (drawerOpen) {
    backdrop = <Backdrop close={backdropClickHandler} />;
  }

  const reloadHandler = () => {
    checkForUpdate();
  };

  const handleNotificationClose = () => {
    // This function is required by Snackbar.
    // We can leave it empty or add logging.
  };

  return (
    <Router>
      <ErrorBoundary fallback={<ErrorPage />}>
        <LoadValidations />
        <Sidebar
          sidebar={
            <SideNav backdrop={backdropClickHandler} updateChecker={reloadHandler} />
          }
          open={drawerOpen}
          styles={{
            sidebar: {
              background: "white",
              top: 60,
              position: "fixed",
              zIndex: "500",
            },
          }}
          children={" "}
        />
        <NavBar show={drawerOpen} toggle={drawerToggleClickHandler} />
        {backdrop}
        {/* Spinner controlled by the hook's state */}
        {isCheckingForUpdate && <Spinner />}
        {/* Renders when `isUpdateAvailable` is true */}
        {isUpdateAvailable && (
          <UpdatePwa handleOpen={isUpdateAvailable} handleClose={handleClose} />
        )}
        {/* Renders when `noUpdateAvailable` is true */}
        <NotificationSnackbar
          handleOpen={noUpdateAvailable}
          message={"You are already on the latest version."}
          onClose={handleNotificationClose}
        />
        {/* Renders when `updateError` has a message */}
        <NotificationSnackbar
          handleOpen={!!updateError}
          message={updateError}
          onClose={handleNotificationClose}
        />
        <Main />
        <BottomNav updateChecker={reloadHandler} />
      </ErrorBoundary>
    </Router>
  );
}
